import { render, staticRenderFns } from "./TransactionOrderDetail.vue?vue&type=template&id=2f461540&"
import script from "./TransactionOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports